module.exports = __webpack_public_path__ + "static/media/2.22ec1ec5.webp";